<template>
  <v-layout>
    <v-row>
      <v-col cols="12">
        <v-select
            class="mt-0 pt-0"
            v-model="standardFilters.confirmed"
            label="Potwierdzony"
            :items="confirmedValues"
            item-value="value"
            item-text="text"
            hide-details
        ></v-select>
      </v-col>
      <v-col cols="12">
        <v-select
            class="mt-0 pt-0"
            v-model="standardFilters.companyType"
            label="Typ firmy"
            :items="companyTypeValues"
            item-value="value"
            item-text="text"
            hide-details
        ></v-select>
      </v-col>
      <v-col cols="12">
        <v-text-field
            class="mt-0 pt-0"
            v-model="debouncedFilters.email"
            label="Email"
            placeholder=" "
            :counter="254"
            :rules="rules.textFilter"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
            class="mt-0 pt-0"
            v-model="debouncedFilters.name"
            label="Imię"
            placeholder=" "
            :counter="100"
            :rules="rules.textFilter"
        />
      </v-col>
      <v-col cols="12">
        <v-text-field
            class="mt-0 pt-0"
            v-model="debouncedFilters.surname"
            label="Nazwisko"
            placeholder=" "
            :counter="100"
            :rules="rules.textFilter"
        />
      </v-col>
      <v-col cols="12">
        <v-checkbox
            class="mt-0 pt-0"
            v-model="standardFilters.showGuests"
            label="Pokazuj również gości"
            hide-details
        ></v-checkbox>
      </v-col>
      <v-col cols="12">
        <v-checkbox
            class="mt-0 pt-0"
            v-model="standardFilters.onlyHavingFbIds"
            label="Tylko użytkownicy posiadający tokeny Firebase"
            hide-details
        >
          <template v-slot:append>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">mdi-help-circle</v-icon>
              </template>
              Czyli użytkownicy, do których możemy wysyłać powiadomienia na urządzenia mobilne.
            </v-tooltip>
          </template>
        </v-checkbox>
      </v-col>
      <v-col cols="12">
        <v-checkbox
            class="mt-0 pt-0"
            v-model="standardFilters.showDeleted"
            label="Pokazuj również usuniętych"
            hide-details
        />
      </v-col>
    </v-row>
  </v-layout>
</template>

<script>
import {setDatatableFilters} from "@/utils/helpers";
import debounce from "debounce";

export default {
  data() {
    return {
      filterCodesDebouncing: null,
      standardFilters: {
        confirmed: '',
        showGuests: false,
        onlyHavingFbIds: false,
        showDeleted: false,
        companyType: '',
      },
      debouncedFilters: {
        email: '',
        name: '',
        surname: '',
      },
      confirmedValues: [
        {value: '', text: 'Obojętnie'},
        {value: '0', text: 'Nie'},
        {value: '1', text: 'Tak'},
      ],
      companyTypeValues: [
        {value: '', text: 'Obojętnie'},
        {value: 'C', text: 'Zbierający'},
        {value: 'E', text: 'Wytwarzający'},
        {value: 'N', text: 'Osoba fizyczna'},
      ],
      rules: {
        textFilter: [
          (value) => {
            if (!value) {
              return true;
            }

            return value.length >= 2 || 'Wpisz co najmniej dwa znaki.'
          },
        ],
      },
    };
  },
  created() {
    this.filterUsersDebouncing = debounce(function () {
      this.filterUsers();
    }, 500);
  },
  watch: {
    standardFilters: {
      handler() {
        setDatatableFilters.call(this);
        this.filterUsers();
      },
      deep: true
    },
    debouncedFilters: {
      handler() {
        setDatatableFilters.call(this);
        this.filterUsersDebouncing();
      },
      deep: true
    },
  },
  methods: {
    filterUsers() {
      this.$root.$emit('loadUsers', {
        filters: {
          ...this.standardFilters,
          ...this.debouncedFilters,
        },
        onSuccess: () => {
          this.$root.$emit('notify', {
            html: 'Filtrowanie zakończone.',
          });
        }
      });
    },
  }
}
</script>